import { render, staticRenderFns } from "./wiseGuide.vue?vue&type=template&id=564cd014&scoped=true"
import script from "./wiseGuide.vue?vue&type=script&lang=js"
export * from "./wiseGuide.vue?vue&type=script&lang=js"
import style0 from "./wiseGuide.vue?vue&type=style&index=0&id=564cd014&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564cd014",
  null
  
)

export default component.exports